import React from "react";

import {
    Card,
    Description,
    Header,
    HeaderRight,
    HeaderText,
    Title,
} from "./styles";

interface SectionCardProps {
    title?: React.ReactNode;
    description?: React.ReactNode;
    headerRight?: React.ReactNode;
    tone?: "default" | "danger";
    className?: string;
    children: React.ReactNode;
}

export const SectionCard = ({
    title,
    description,
    headerRight,
    tone = "default",
    className,
    children,
}: SectionCardProps) => (
    <Card className={className} $tone={tone}>
        {(title || headerRight) && (
            <Header>
                <HeaderText>
                    {title && <Title>{title}</Title>}
                    {description && <Description>{description}</Description>}
                </HeaderText>
                {headerRight && <HeaderRight>{headerRight}</HeaderRight>}
            </Header>
        )}
        {children}
    </Card>
);
